import { SegmentEvent } from 'types/TripSegment';

import { EventCreator } from './types';

export function getEvents<T>(...fns: EventCreator<T>[]) {
    return (order: T): SegmentEvent[] => fns.map(fn => fn(order));
}
